import { Content } from "src/shared/components/content";

export const ForTheFuture = () => (
  <svg version="1.1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <title>
      <Content id="cid$#2984767#" />
    </title>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1180 -292)">
        <g transform="translate(1180 292)">
          <circle cx="100" cy="100" r="100" fill="#E8F4D9" />
          <g transform="translate(57.143 57.143)" strokeLinejoin="round" strokeWidth="4.2914">
            <polyline
              id="Path"
              points="13.794 50.683 0 74.534 14.167 71.926 19.386 85.714 31.689 65.217"
              stroke="#264A19"
            />
            <polyline
              id="Path"
              points="71.579 51.056 85 74.534 70.833 71.926 65.987 85.714 53.684 65.217"
              stroke="#264A19"
            />
            <path
              id="a"
              d="m42.873 67.081c18.531 0 33.553-15.017 33.553-33.54s-15.022-33.54-33.553-33.54c-18.531 0-33.553 15.017-33.553 33.54s15.022 33.54 33.553 33.54z"
              stroke="#264A19"
            />
            <polygon
              points="42.873 14.907 48.465 26.087 59.649 26.087 50.329 35.404 54.057 48.447 42.873 41.366 31.689 48.447 35.417 35.404 26.097 26.087 37.281 26.087"
              stroke="#8CC63F"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
